import React from 'react';
import { ButtonGroup, Button } from '@material-ui/core';


const FieldTestReviewButtons = ({ orientation="vertical", fieldTest, handleClick }) => {
  return (
    <ButtonGroup orientation={orientation} style={{ width: "100%" }}>
      <Button size="small" onClick={(event) => handleClick(fieldTest, event)} color="primary">Engineering Judgement</Button>
      <Button size="small" onClick={(event) => handleClick(fieldTest, event)} color="primary">Acknowledge Result</Button>
      <Button size="small" onClick={(event) => handleClick(fieldTest, event)} color="primary">Not Incorporated</Button>
    </ButtonGroup>
  )
}

export default FieldTestReviewButtons;